var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSolutions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82.623,
    height: 111.577,
    viewBox: "0 0 82.623 111.577",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "layer2",
    d: "M89.623,110.577,49.812,85.242,10,110.577V2H89.623Z",
    transform: "translate(-8.5 -0.5)",
    fill: "none",
    stroke: "#e8ad5a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "layer1",
    d: "M43.335,50.554,27.591,61.774,33.744,43.5,18,32.277H37.363L43.335,14l5.972,18.277H68.669L52.926,43.5,58.9,61.774,43.335,50.554Z",
    transform: "translate(-2.023 9.215)",
    fill: "none",
    stroke: "#83b1d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSolutions);
export default __webpack_public_path__ + "static/media/icon-solutions.5457b8de6b836bfca4b6ce5301ec31e1.svg";
export { ForwardRef as ReactComponent };